module.exports = __webpack_public_path__ + "img/menu.9eff056a.jpg";